import React from 'react'
import { observer } from 'mobx-react'
import Helmet from 'react-helmet'
import { HeaderSink, HeaderTitle } from 'components/Header'
import intercomUpdate from 'decorators/intercomUpdate'
import ShadowBox from 'components/ShadowBox'
import PaymentMethods from 'components/PaymentMethods'
import ContentLoading from 'components/ContentLoading'
import ContentError from 'components/ContentError'

import './styles.sass'

@intercomUpdate({ screen: 'Billing' })
@observer
export default class BillingScreen extends React.Component {
  componentWillMount () {
    this.props.rootStore.billingScreenStore.activate()
  }

  render () {
    const { billingStore, billingScreenStore } = this.props.rootStore
    return (
      <div className="billing-screen">
        <Helmet title="Billing" />
        <HeaderSink small>
          <HeaderTitle>
            Billing
          </HeaderTitle>
        </HeaderSink>

        <div className="container has-spacing-top has-spacing-bottom">
          <div className="columns">
            <div className="column is-8 is-offset-2">
            <div className="has-text-centered">
              <div className="box-title">Payment methods</div>
              <div className="box-description">
                <p>
                  Your current card will be used to bill you for the balance of your quote once your Tax Pro marks your job complete.
                  The service fee is billed when you submit a job, but if you need to use a different card for the
                  remaining portion of your quote, you can do that here.
                </p>
                <p>
                  Please note that at least one card must be on file at all times.
                </p>
              </div>
            </div>
            </div>
          </div>
          <div className="columns">
            <div className="column is-8 is-offset-2">
              {billingScreenStore.fetchCards.match({
                pending: () => <ContentLoading />,
                rejected: (err) => <ContentError error={err} />,
                resolved: () => (
                  <ShadowBox>
                    <PaymentMethods
                      loading={billingScreenStore.fetchCards.pending}
                      cards={billingStore.cards}
                      busy={billingStore.busy}
                      onAddClick={() => billingStore.showAddCardCheckout()}
                      onDeleteCardClick={card => billingStore.deletePaymentMethod(card)}
                      onCardClick={card => billingStore.changeDefaultMethod(card)}
                    />
                  </ShadowBox>
                )
              })}
            </div>
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/client/screens/Billing/index.jsx